import storageService from '../../services/storageService'
import {USER_CONFIG} from '../../config/UserConfig'

function adicionarPessoa(context, payload) {     
    storageService.setJsonItem(USER_CONFIG.loggedUser,payload);
    context.commit('ADD_PESSOA_PARTICIPANTE', payload)
 }

 function adicionarTokenSessao(context, payload) {
   const {token} = payload;
   delete payload.token;
   storageService.setItem(USER_CONFIG.token, token);//user token
   context.commit('ADD_TOKEN_SESSAO_PARTICIPANTE', payload)
}

function obterPessoaPreCarregada(context){
   const pessoa = storageService.getJsonItem(USER_CONFIG.loggedUser);
   const token  = storageService.getItem(USER_CONFIG.token);
   
   if(pessoa && token){
      context.commit('ADD_PESSOA_PARTICIPANTE', pessoa)
      context.commit('ADD_TOKEN_SESSAO_PARTICIPANTE', token)
   }
}

 
 
 export default {
    adicionarPessoa,
    adicionarTokenSessao,
    obterPessoaPreCarregada
 }


// WEBPACK FOOTER //
// ./src/store/actions/pessoa.action.js